import defaultFormsConstants from './default';

export default defaultFormsConstants;
